<template>
  <div class="investor-team">
    <draggable v-model="members" :options="{ handle: '.ion-drag' }">
      <TeamMember
        v-for="member in members"
        :key="member.id"
        :member="member"
        :editable="editable"
        @member-updated="memberUpdated"
        @member-deleted="memberDeleted"
      />
    </draggable>

    <div v-if="editable" class="row">
      <div class="col-sm-12">
        <button class="btn btn-primary btn-transparent" @click="addMember()">
          Add member
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import TeamMember from './TeamMember'
import * as updater from './updater'
import draggable from 'vuedraggable'
import { mapState } from 'vuex'

export default {
  components: { draggable, TeamMember },
  props: {
    editable: { type: Boolean, default: false },
  },
  computed: {
    members: {
      get() {
        return this.investor.members
      },
      set(members) {
        updater.updateField('members', members)
        this.$store.dispatch('investorProfile/refetch') // so member ids are retrieved
      },
    },
    ...mapState({
      investor: (state) => state.investorProfile.investor,
    }),
  },

  methods: {
    async memberUpdated(member) {
      const members = this.members.map((m) => {
        if (m.id === member.id) {
          return member
        } else {
          return m
        }
      })
      await updater.updateField('members', members)
      this.$store.dispatch('investorProfile/refetch') // so member ids are retrieved
    },

    async memberDeleted(member) {
      await updater.updateField(
        'members',
        this.members.filter((m) => m.id !== member.id),
      )
      this.$store.dispatch('investorProfile/refetch') // so member ids are retrieved
    },

    addMember() {
      this.$store.commit('investorProfile/ADD_NEW_MEMBER')
    },
  },
}
</script>
